import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Header/Navbar';
import './App.css';

// AUTH
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import VerifyOtp from './pages/Auth/VerifyOtp';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import ChangePassword from './pages/Auth/ChangePassword';
import Settings from "./pages/Setting/Settings";

// KB
import KnowledgeBase from './pages/KnowledgeBase/KnowledgeBase';
import AdminKnowledgeBase from './pages/KnowledgeBase/AdminKnowledgeBase';
import ProtectedRoute from './components/ProtectedRoute';
import RequireRole from './components/RequireRole';
import KnowledgeBaseArticle from './pages/KnowledgeBase/KnowledgeBaseArticle';

// TICKETS
import MyTickets from './pages/Tickets/MyTickets';
import NewTicket from './pages/Tickets/NewTicket';
import TicketDetail from './pages/Tickets/TicketDetail';
import CreateStaff from './pages/Admin/CreateStaff';

import AdminPanel from './pages/Admin/AdminPanel';

// Import pages
import Home from './pages/Home/Home';
import Services from './pages/Services/Services';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Partners from './pages/Partners/Partners';
import Footer from './components/layout/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import MaritimeSystems from './pages/Services/MaritimeSystems'
import WirelessInfrastructure from './pages/Services/WirelessInfrastructure'
import HybridCloudHosting from './pages/Services/HybridCloudHosting'
import CablingSolutions from './pages/Services/CablingSolutions'
import IntelligentSmartCitiesSolutions from './pages/Services/IntelligentSmartCitiesSolutions'
import CyberSecurityInfrastructure from './pages/Services/CyberSecurityInfrastructure'
import CollaborationSolutionsPage from './pages/Services/CollaborationSolutionsPage';
import ContactCenter from './pages/Services/ContactCenter'
import CloudInfrastructure from './pages/Services/CloudInfrastructure'
import Connectivity from './pages/Services/Connectivity'
import SecuritySolutions from './pages/Services/SecuritySolutions'
import UnifiedCommunications from './pages/Services/UnifiedCommunications'
import NetworkInfrastructure from './pages/Services/NetworkInfrastructure'
import DataCenterServices from './pages/Services/DataCenterServices'


function App() {

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />

        {/* Main content area */}
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify" element={<VerifyOtp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />

            <Route path="/services" element={<Services />} />
            <Route path="/services/Maritime-Systems" element={<MaritimeSystems />} />
            <Route path="/services/Wireless-Infrastructure" element={<WirelessInfrastructure />} />
            <Route path="/services/Hybrid-Cloud-Hosting" element={<HybridCloudHosting />} />
            <Route path="/services/Cabling-Solutions" element={<CablingSolutions />} />
            <Route path="/services/Intelligent-Smart-Cities-Solutions" element={<IntelligentSmartCitiesSolutions />} />
            <Route path="/services/Cyber-Security-Infrastructure" element={<CyberSecurityInfrastructure />} />
            <Route path="/services/Collaboration-Solutions" element={<CollaborationSolutionsPage />} />
            <Route path="/services/Contact-Center" element={<ContactCenter />} />
            <Route path="/services/Cloud-Infrastructure" element={<CloudInfrastructure />} />
            <Route path="/services/Connectivity" element={<Connectivity />} />
            <Route path="/services/Security-Solutions" element={<SecuritySolutions />} />
            <Route path="/services/Unified-Communications" element={<UnifiedCommunications />} />
            <Route path="/services/Network-Infrastructure" element={<NetworkInfrastructure />} />
            <Route path="/services/Data-Center-Services" element={<DataCenterServices />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/About" element={<About />} />
            <Route path="/Partners" element={<Partners />} />

            {/* Admin Panel */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <RequireRole allow={['ADMIN']}>
                    <AdminPanel />
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            {/* Knowledge Base */}
            <Route
              path="/knowledge-base"
              element={
                <ProtectedRoute>
                  <KnowledgeBase />
                </ProtectedRoute>
              }
            />
            <Route
              path="/knowledge-base/:id"
              element={
                <ProtectedRoute>
                  <KnowledgeBaseArticle />
                </ProtectedRoute>
              }
            />


            <Route
              path="/admin/knowledge-base"
              element={
                <ProtectedRoute>
                  <RequireRole allow={['ADMIN']}>
                    <AdminKnowledgeBase />
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            {/* Support Ticket */}
            <Route
              path="/tickets"
              element={
                <ProtectedRoute>
                  <MyTickets />
                </ProtectedRoute>
              }
            />

            <Route
              path="/tickets/new"
              element={
                <ProtectedRoute>
                  <NewTicket />
                </ProtectedRoute>
              }
            />

            <Route
              path="/tickets/:id"
              element={
                <ProtectedRoute>
                  <TicketDetail />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/create-staff"
              element={
                <ProtectedRoute>
                  <RequireRole allow={['ADMIN']}>
                    <CreateStaff />
                  </RequireRole>
                </ProtectedRoute>
              }
            />

          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
